import { fromJS } from "immutable";
import {
    SET_CURRENT_QUESTION_TYPE,
    SET_REMAINING_TIME,
    SET_TIME_COMPLETED,
    SET_VIDEO_COMPLETED,
    SET_VIDEO_ANSWER_RECORDING
} from "../constants/app";

const initialState = fromJS({
    currentQuestionType: "",
    timeCompleted: false,
    videoCompleted: false,
    remainingTime: 0,
    videoAnswerRecording: "not started", // not started, recording, uploading, uploaded
});

const AppReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_CURRENT_QUESTION_TYPE:
            return state.set("currentQuestionType", action.data);

        case SET_TIME_COMPLETED:
            return state.set("timeCompleted", action.data);

        case SET_VIDEO_COMPLETED:
            return state.set("videoCompleted", action.data);

        case SET_REMAINING_TIME:
            return state.set("remainingTime", action.data);

        case SET_VIDEO_ANSWER_RECORDING:
            return state.set("videoAnswerRecording", action.data);

        default:
            return state;
    }
};

export default AppReducer;
